import App from '@/models/App'
import Profile from '@/models/Profile'

export default class SelectOrganization extends App {
    static get entity() {
        return 'SelectOrganizations'
    }
    static all() {
        return this.query().withAllRecursive().get()
    }
    static one() {
        return this.query().first()
    }
    static fields() {
        return {
            id: this.attr(''),
            code: this.attr(''),
            nameJa: this.attr(''),
            nameEn: this.attr(''),
            display: this.attr(''),
            value: this.attr(''),
        }
    }

    static apiConfig = {
        actions: {
            fetch() {
                return this.get(`/organizations`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.attendURL(),
                })
            },
        },
    }
}
